// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-name {
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: AppFontSemiBold;
  font-size: 15px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  margin-bottom: 6.5px;
}

@media (min-width: 991px) {
  .item-image {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    padding: 18px 0;
    border: 0;
    height: 160px;
  }
}

.info-text {
  flex: 1;
}
.info-text .info {
  margin: 0;
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 110%;
  letter-spacing: 0;
  color: var(--color-grey);
  margin-bottom: 10px;
}

.action-icon {
  width: 29px;
  height: 29px;
  margin-left: 25px;
}
@media (min-width: 991px) {
  .action-icon {
    display: none;
  }
}

.price-col {
  display: flex;
  flex-direction: column;
}

.price {
  margin: 0;
  font-family: AppFontMedium;
  font-size: 15px;
  line-height: 110%;
  letter-spacing: 0;
  vertical-align: middle;
  text-align: right;
  margin-bottom: 12px;
  text-transform: uppercase;
}

.add-product-icon {
  height: 32px;
  width: 32px;
  margin-left: auto;
}

.item-row {
  margin-bottom: 20px;
  padding: 0px;
  height: 91%;
  min-height: 90px;
}
@media (min-width: 991px) {
  .item-row {
    background: transparent;
    border-radius: 0;
    cursor: pointer;
    height: 100%;
    border: 1.5px solid transparent;
    transition: border 0.2s ease;
  }
  .item-row ion-img {
    height: 100%;
  }
}

.item-info {
  padding: 0;
  padding-right: 8px;
  padding-left: 8px;
  height: 83%;
}
@media (min-width: 991px) {
  .item-info {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
}

app-tag {
  margin-left: 3px;
}

.lines-col {
  padding: 6px 0px 3px;
}
@media (min-width: 991px) {
  .lines-col {
    height: min-content;
    margin-top: auto;
  }
}

.first-line {
  display: block;
  height: 0.5px;
  width: 100%;
  margin: 0px 0px 0px 0px;
  opacity: 0.5;
  content: "";
  background: #939393;
}

.second-line {
  display: block;
  height: 1px;
  width: 100%;
  margin: 5px 0px;
  content: "";
  background: #939393;
}

.add-btn {
  width: 25px;
  height: 25px;
  background: var(--ion-color-secondary);
  color: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin: 0px 0px 0px 5px;
}
@media (min-width: 991px) {
  .add-btn {
    display: none;
  }
}

.pfand-meirnveg {
  margin: 0;
  font-size: 12px;
}

.item-img {
  padding: 0;
}
@media (min-width: 991px) {
  .item-img {
    display: block;
  }
}

.image-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 4px;
  overflow: hidden;
}
@media (min-width: 991px) {
  .image-wrapper {
    padding: 0px;
  }
}
.image-wrapper .default-img {
  padding: 20px;
  object-fit: contain;
  background-color: #fff;
}
.image-wrapper ion-img {
  border-radius: 1px;
  overflow: hidden;
  object-fit: cover;
  width: 100%;
  aspect-ratio: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EAEA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,oBAAA;AAHD;;ACdE;EDoBF;IAEE,sBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,SAAA;IACA,aAAA;EAHA;AACF;;AAMA;EACC,OAAA;AAHD;AAKC;EACC,SAAA;EACA,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EAEA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;EAEA,mBAAA;AALF;;AASA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAND;ACrDE;EDwDF;IAKE,aAAA;EAJA;AACF;;AAOA;EACC,aAAA;EACA,sBAAA;AAJD;;AAOA;EACC,SAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EAEA,iBAAA;EACA,mBAAA;EACA,yBAAA;AAND;;AAcA;EACC,YAAA;EACA,WAAA;EACA,iBAAA;AAXD;;AAcA;EACC,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAXD;ACxFE;ED+FF;IAOE,uBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,+BAAA;IACA,4BAAA;EAVA;EAgBA;IACC,YAAA;EAdD;AACF;;AAkBA;EACC,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAfD;AC5GE;EDuHF;IAOE,aAAA;IACA,sBAAA;IACA,2BAAA;EAdA;AACF;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,oBAAA;AAdD;AC3HE;EDwIF;IAIE,mBAAA;IACA,gBAAA;EAbA;AACF;;AAgBA;EACC,cAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAbD;;AAeA;EACC,cAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAZD;;AAcA;EACC,WAAA;EACA,YAAA;EACA,sCAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;AAXD;ACjKE;EDkKF;IAYE,aAAA;EATA;AACF;;AAYA;EACC,SAAA;EACA,eAAA;AATD;;AAYA;EACC,UAAA;AATD;AC/KE;EDuLF;IAGE,cAAA;EAPA;AACF;;AAUA;EACC,kBAAA;EAIA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAVD;AC5LE;ED8LF;IAWE,YAAA;EATA;AACF;AAUC;EACC,aAAA;EACA,mBAAA;EACA,sBAAA;AARF;AAUC;EACC,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AARF","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.item-name {\n\tflex: 1;\n\tword-break: break-word;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 2;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\n\tfont-family: AppFontSemiBold;\n\tfont-size: 15px;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\n\tmargin-bottom: 6.5px;\n}\n\n.item-image {\n\t@include desktop {\n\t\tbox-sizing: border-box;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: transparent;\n\t\tpadding: 18px 0;\n\t\tborder: 0;\n\t\theight: 160px;\n\t}\n}\n\n.info-text {\n\tflex: 1;\n\n\t.info {\n\t\tmargin: 0;\n\t\tflex: 1;\n\t\tword-break: break-word;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 3;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\n\t\tfont-size: 12px;\n\t\tleading-trim: NONE;\n\t\tline-height: 110%;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--color-grey);\n\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n.action-icon {\n\twidth: 29px;\n\theight: 29px;\n\tmargin-left: 25px;\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.price-col {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.price {\n\tmargin: 0;\n\n\tfont-family: AppFontMedium;\n\tfont-size: 15px;\n\tline-height: 110%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\n\ttext-align: right;\n\tmargin-bottom: 12px;\n\ttext-transform: uppercase;\n\n\t// @include desktop {\n\t//   // padding: 20px 12px;\n\t//   text-align: left;\n\t// }\n}\n\n.add-product-icon {\n\theight: 32px;\n\twidth: 32px;\n\tmargin-left: auto;\n}\n\n.item-row {\n\tmargin-bottom: 20px;\n\tpadding: 0px;\n\theight: 91%;\n\tmin-height: 90px;\n\n\t@include desktop {\n\t\tbackground: transparent;\n\t\tborder-radius: 0;\n\t\tcursor: pointer;\n\t\theight: 100%;\n\t\tborder: 1.5px solid transparent;\n\t\ttransition: border 0.2s ease;\n\n\t\t// &:hover {\n\t\t// \tborder: 1.5px solid var(--ion-color-primary);\n\t\t// }\n\n\t\tion-img {\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n\n.item-info {\n\tpadding: 0;\n\tpadding-right: 8px;\n\tpadding-left: 8px;\n\theight: 83%;\n\t@include desktop {\n\t\t// padding: 20px 12px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: flex-start;\n\t}\n}\n\napp-tag {\n\tmargin-left: 3px;\n}\n\n.lines-col {\n\tpadding: 6px 0px 3px;\n\n\t@include desktop {\n\t\theight: min-content;\n\t\tmargin-top: auto;\n\t}\n}\n\n.first-line {\n\tdisplay: block;\n\theight: 0.5px;\n\twidth: 100%;\n\tmargin: 0px 0px 0px 0px;\n\topacity: 0.5;\n\tcontent: '';\n\tbackground: #939393;\n}\n.second-line {\n\tdisplay: block;\n\theight: 1px;\n\twidth: 100%;\n\tmargin: 5px 0px;\n\tcontent: '';\n\tbackground: #939393;\n}\n.add-btn {\n\twidth: 25px;\n\theight: 25px;\n\tbackground: var(--ion-color-secondary);\n\tcolor: #ffffff;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 18px;\n\tmargin: 0px 0px 0px 5px;\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.pfand-meirnveg {\n\tmargin: 0;\n\tfont-size: 12px;\n}\n\n.item-img {\n\tpadding: 0;\n\t@include desktop {\n\t\tdisplay: block;\n\t}\n}\n\n.image-wrapper {\n\tposition: relative;\n\t// padding: 7px 0;\n\t// height: 100%;\n\t// max-width: 100px;\n\twidth: 100%;\n\taspect-ratio: 1;\n\tborder-radius: 4px;\n\toverflow: hidden;\n\n\t@include desktop {\n\t\tpadding: 0px;\n\t}\n\t.default-img {\n\t\tpadding: 20px;\n\t\tobject-fit: contain;\n\t\tbackground-color: #fff;\n\t}\n\tion-img {\n\t\tborder-radius: 1px;\n\t\toverflow: hidden;\n\t\tobject-fit: cover;\n\t\twidth: 100%;\n\t\taspect-ratio: 1;\n\t\t@include mobile {\n\t\t\t// max-height: 100px;\n\t\t\t// min-height: 100px;\n\t\t}\n\t}\n}\n\n// .item-row:not(:has(.main-img)) {\n// \tmin-height: 30px;\n\n// \t.item-img {\n// \t\tdisplay: none;\n// \t}\n\n// \t.image-wrapper {\n// \t\tdisplay: none;\n// \t}\n\n// \t.item-info {\n// \t\theight: 72%;\n// \t}\n// }\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
